import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function cnpjValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        let value = control.value;

        if (!value) {
            return null;
        }

        // 1. Limpeza e Normalização
        // Removemos pontos, traços e barras, mas PRESERVAMOS letras e números
        const cnpj = value.toString().toUpperCase().replace(/[.\-\/]/g, '').trim();

        // 2. Validação Lexical básica
        // Verifica se tem 14 caracteres e se não contém as letras proibidas (F, I, O, Q, U)
        const padraoCnpj = /^(?:(?![FIOQU])[A-Z0-9]){12}\d{2}$/;
        if (!padraoCnpj.test(cnpj)) {
            return { cnpjInvalido: true };
        }

        // 3. Regra de Cálculo Alfanumérico (Módulo 11 + ASCII - 48)
        const getCnpjCharValue = (c: string): number => {
            // charCodeAt(0) retorna o valor ASCII
            // '0' = 48 -> 48 - 48 = 0
            // 'A' = 65 -> 65 - 48 = 17
            return c.charCodeAt(0) - 48;
        };

        const calcDigito = (cnpjParcial: string, pesos: number[]): number => {
            let soma = 0;
            for (let i = 0; i < pesos.length; i++) {
                soma += getCnpjCharValue(cnpjParcial.charAt(i)) * pesos[i];
            }
            const resto = soma % 11;
            return resto < 2 ? 0 : 11 - resto;
        };

        // 4. Execução dos Cálculos
        const cnpjBase = cnpj.substring(0, 12);
        const digito1 = calcDigito(cnpjBase, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
        const digito2 = calcDigito(cnpjBase + digito1, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

        const cnpjValido = cnpj.endsWith(`${digito1}${digito2}`);

        return cnpjValido ? null : { cnpjInvalido: true };
    };
}